<template>
  <el-dialog v-el-drag-dialog :visible.sync="innerVisible" :title="$t('AirExport.SelectAirPort')" width="700px" :close-on-click-modal="false" append-to-body>
    <el-form :inline="true" label-width="60px" label-position="left">
      <el-form-item :label="$t('CargoMsg.Cargo_Country')">
        <cargo-advance-select
          :select-type="TYPE_NAMES.basic_data_Country"
          filterable
          :default-value="country"
          style="width: 300px;"
          @parentCallBack="p=>{country=p.value}"
        />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_Code')">
        <el-input v-model="code" style="width: 150px;" />
      </el-form-item>
    </el-form>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="filteredRowData"
      style="height: 350px;"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <el-button type="primary" @click="commitHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { sleep, ensureExecuteSuccess } from '@/utils/commonUtil'

export default {
  name: 'AirPortSelectDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    codes: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      TYPE_NAMES,
      country: '',
      code: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: '',
          width: 55,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_PODcode'),
          field: 'code'
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName'
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName'
        }, {
          headerName: this.$t('CargoMsg.Cargo_Country'),
          field: 'countryCode',
          valueGetter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.data.countryCode, 'name')
          }
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null
    }
  },
  computed: {
    filteredRowData() {
      return this.rowData.filter(p => {
        if (this.country && p.countryCode !== this.country) {
          return false
        }
        if (this.code.trim()) {
          return p.code.indexOf(this.code.trim()) > -1
        }
        return true
      })
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.rowData = getCacheListByKey(TYPE_NAMES.basic_data_Airport)
          if (this.codes.length > 0) {
            if (this.gridApi) {
              await sleep(100)
            } else {
              await ensureExecuteSuccess(() => this.gridApi)
            }
            for (const item of this.gridApi.rowModel.rowsToDisplay) {
              if (this.codes.includes(item.data.code)) {
                item.setSelected(true)
              }
            }
          }
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.countryCode = ''
        this.code = ''
        this.rowData = []
      }
    }
  },
  methods: {
    commitHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('AirExport.PleaseSelectAPort'))
        return
      }
      this.$emit('callback', rows)
      this.innerVisible = false
    }
  }
}
</script>
